import { connect } from 'react-redux';
import getErrorMessage from '../../../lib/utils/getErrorMessage';
import {
  requestNewProgramCard,
  resetAddressError,
  resolveLocationFromZipCode,
  validateShippingAddress,
} from '../../reducers/actions';
import Form from '../ShippingAddressForm/ShippingAddressForm';

const defaultErrorMsg = 'There was an error updating shipping address, please try again later.';

const mapStateToProps = ({ auth, geo, progress, shippingAddress, wallet }) => ({
  action: '/switch',
  address: wallet?.status?.shipping_address,
  defaultPostalCode: progress?.postal,
  email: auth.email || progress.email,
  error: getErrorMessage(shippingAddress.error, defaultErrorMsg),
  errorFetchingLocationInfo: geo.error,
  firstName: wallet.status?.name?.first_name,
  isFetchingLocationInfo: geo.isFetching,
  isLoggedIn: !!auth.account_id,
  isUpdating: !!shippingAddress?.isSwitching,
  isValidating: shippingAddress?.isValidating,
  lastName: wallet.status?.name?.last_name,
  locationInfo: geo.location,
  result: shippingAddress?.result,
  title: 'Change Address',
  subheader: 'We will send your new Pay with GasBuddy+™ card to the address below:',
  primaryButtonText: 'Confirm Address',
});

const mapDispatchToProps = dispatch => ({
  fetchLocationInfo: zipcode => dispatch(resolveLocationFromZipCode(zipcode)),
  resetAddressError: () => dispatch(resetAddressError()),
  saveShippingAddress: (body) => {
    dispatch(requestNewProgramCard(body));
  },
  validateShippingAddress: (body, analyticsContext) => {
    dispatch(validateShippingAddress(body, analyticsContext));
  },
});

const SwitchToNewProgramForm = connect(mapStateToProps, mapDispatchToProps)(Form);
export default SwitchToNewProgramForm;
